import { useEffect, useState } from "react";

import {
  change,
  Field,
  getFormValues,
  InjectedFormProps,
  reduxForm,
  reset,
} from "redux-form";

import model from "../../../module/form/modelSchema";
import { IDataPostLogin, LOGIN_FORM } from "../module/constants";
import { connect } from "react-redux";

import { FormattedMessage } from "react-intl";
import messages from "../module/messages";

import onSubmit from "./onSubmit";
import TextInputFieldUI from "../../../components/TextInputField/TextInputField";
import { push } from "connected-react-router";
import OutlinedButton from "../../../ui/OutlinedButton/OutlinedButton";
import {
  getDomains,
  generateLoginOtpRequest,
  postOTPAction,
} from "../module/actions";
import {
  setAccessFromInternetAction,
  setToken,
  setTriggerErrorModal,
} from "../../../App/module/actions";
import { ContactsType } from "../../../components/Modals/ContactsModal/module/constants";
import { OtpOperationType, ROUTES } from "../../../module/constants";
import TwoFactorAuth from "../../../common/TwoFactorAuth/TwoFactorAuth";
import classes from "../index.module.scss";
import OTPModal from "../../../components/Modals/PwdMgmtModals/OTPModal/OTPModal";
import OtpCaMobileModal from "../../../components/Modals/OtpCaMobileModal/OtpCaMobileModal";
import { sendInternetOtpLogin } from "../module/services";
import ResponseModal from "../../../components/Modals/ResponseModal/ResponseModal";
import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import CaMobileResponseModal from "../../../components/Modals/CaMobileResponseModal/CaMobileResponseModal";

interface ILoginFormProps {
  resetForm: () => {};
  changeLocation: (url: string) => void;
  formValues: any;
  changeForm: (field: string, value: any) => {};
  generateLoginOTP: (body: {
    operation: OtpOperationType;
    method: ContactsType;
    userCode?: string;
  }) => void;
  postOtp: (body: IDataPostLogin) => void;
  isFirstAccess: boolean;
  test: boolean;
  isFromInternet: boolean;
  setToken: (token: string) => void;
  setAccessFromInternet: (isFromInternet: boolean) => void;
  triggerErrorModal: (trigger: boolean) => void;
}

const form = LOGIN_FORM;
const formModel = model[LOGIN_FORM];

const submitting = (e: any, handleSubmit: any) => {
  e.preventDefault();
  handleSubmit();
};

const LoginForm: React.FC<
  ILoginFormProps & InjectedFormProps<{}, ILoginFormProps>
> = (props: ILoginFormProps & InjectedFormProps<{}, ILoginFormProps>) => {
  const {
    changeForm,
    formValues,
    handleSubmit,
    changeLocation,
    isFirstAccess,
    isFromInternet,
    setAccessFromInternet,
    triggerErrorModal,
  } = props;

  const [showModals, setShowModals] = useState(false);
  const [showResponseModal, setShowResponseModal] = useState(false);
  const [showCaMobileOtpModal, setShowCaMobileOtpModal] = useState(false);

  const [otpLoginCallState, setOtpLoginCallState] = useState<IResponseState>(
    IResponseState.PENDING
  );

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (isFirstAccess) {
      setShowModals(true);
    }

    if (isFromInternet) {
      setShowCaMobileOtpModal(true);
    }
  }, [isFirstAccess, isFromInternet]);

  const forgotPwdHandler = () => {
    setShowModals(true);
  };

  const confirmOperationHandler = (
    method: "mfaRequired" | "securityQuestionsRequired" | "uigpOTPRequired",
    extra: any
  ) => {};

  const confirmCaMobileHandler = (otp: string) => {
    setShowCaMobileOtpModal(false);
    const checkLoginOtp = (caOtp: string) =>
      sendInternetOtpLogin(caOtp).toPromise();

    setShowResponseModal(true);
    setOtpLoginCallState(IResponseState.PENDING);

    return new Promise<void>((resolve, reject) => {
      checkLoginOtp(otp)
        .then((res: any) => {
          const { access_token, token_type, scope } = res;

          sessionStorage.setItem("token", `${token_type} ${access_token}`);
          setToken(`${token_type} ${access_token}`);
          setAccessFromInternet(true);
          setOtpLoginCallState(IResponseState.SUCCESS);
          return resolve();
        })
        .catch((error: any) => {
          setAccessFromInternet(false);
          setOtpLoginCallState(IResponseState.ERROR);
          return reject();
        });
    });
  };

  const closeResponseModalHandler = () => {
    if (otpLoginCallState === IResponseState.SUCCESS) {
      triggerErrorModal(false);
      changeLocation(ROUTES.WELCOME);
    }
    setShowResponseModal(false);
  };

  return (
    <>
      <CaMobileResponseModal
        show={showResponseModal}
        state={otpLoginCallState}
        onClose={closeResponseModalHandler}
      />
      <OtpCaMobileModal
        show={showCaMobileOtpModal}
        onClose={() => {
          setShowCaMobileOtpModal(false);
          setAccessFromInternet(false);
        }}
        confirmCaOtpHandler={confirmCaMobileHandler}
      />
      {showModals && (
        <TwoFactorAuth
          onClose={() => setShowModals(false)}
          onCloseResponseModal={() => setShowModals(false)}
          confirmOperation={confirmOperationHandler}
          operation={OtpOperationType.FORGOTTEN_PWD}
          isLogin={true}
          showMfa={true}
          showUigp={true}
          firstAccess={isFirstAccess}
        />
      )}

      <form
        onSubmit={(e) => {
          submitting(e, handleSubmit);
        }}
      >
        <div className="row" style={{ rowGap: "1rem" }}>
          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-center flex-wrap">
            <Field
              {...formModel.user}
              component={TextInputFieldUI}
              changeForm={changeForm}
              valueForm={formValues && formValues.user}
              label={<FormattedMessage {...messages.labelUser} />}
            />
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-center flex-wrap">
            <Field
              {...formModel.pwd}
              type={"password"}
              component={TextInputFieldUI}
              changeForm={changeForm}
              valueForm={formValues && formValues.pwd}
              label={<FormattedMessage {...messages.labelPwd} />}
            />
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-center flex-wrap">
            <div className={classes.forgotPwd} onClick={forgotPwdHandler}>
              <FormattedMessage {...messages.forgottenPwd} />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-center flex-wrap">
            <OutlinedButton
              type="submit"
              disabled={formValues ? !formValues.user || !formValues.pwd : true}
            >
              <FormattedMessage {...messages.CTA_LOGIN} />
            </OutlinedButton>
          </div>
        </div>
      </form>
    </>
  );
};
const mapDispatchToProps: any = {
  resetForm: () => reset(form),
  changeForm: (field: string, value: any) => change(form, field, value),
  changeLocation: (url: any) => push(url),
  getDomains: () => getDomains(),
  generateLoginOTP: generateLoginOtpRequest,
  postOtp: postOTPAction,
  setToken,
  setAccessFromInternet: setAccessFromInternetAction,
  triggerErrorModal: setTriggerErrorModal,
};

const mapStateToProps: any = (state: any) => ({
  formValues: getFormValues(form)(state),
  onSubmit: onSubmit,
  isFirstAccess: state.login.firstAccess,
  isFromInternet: state.app.accessFromInternet,
});

const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

const createReduxForm = reduxForm<{}, ILoginFormProps>({
  form,
});

export default withConnect(createReduxForm(LoginForm));
